/**
 * FRVideo — ретушь лица на ВИДЕО поверх того же ядра, что и фото.
 *
 * ГЛАВНАЯ ЗАДАЧА ЗДЕСЬ — НЕ МЕРЦАТЬ
 * ─────────────────────────────────
 * Известная болезнь всех бьюти-фильтров для видео: если обрабатывать каждый
 * кадр независимо, эффект «плавает» — сила ретуши скачет между соседними
 * кадрами, и это видно как дрожание кожи. Причина не в шуме картинки, а в том,
 * что независимая обработка заново ОЦЕНИВАЕТ параметры сцены на каждом кадре,
 * а оценка по одному кадру всегда немного другая.
 *
 * Поэтому здесь параметры сцены измеряются ОДИН РАЗ по выборке кадров всего
 * ролика и дальше не пересчитываются:
 *
 *   · цвет света λ — берётся медиана по выборке (медиана, а не среднее:
 *     один кадр с пересветом не должен утащить весь ролик);
 *   · масштаб лица — оттуда же, он задаёт радиусы полос частот.
 *
 * От кадра к кадру меняется только то, что ОБЯЗАНО меняться: положение маски
 * (лицо движется) и локальный уровень кожи. Величина блика вдобавок
 * сглаживается по времени — она физически не может прыгать за 40 мс.
 *
 * ВТОРОЕ РЕШЕНИЕ — РАЗБОР НА ОБЛАСТИ ЛИЦА, А НЕ НА ВСЁМ КАДРЕ (06.09.2026).
 * Поля модели гладкие по построению (маска от геометрии и растушёвана, поле
 * блика намеренно сглажено, пол — многомасштабное среднее), поэтому их можно
 * считать на уменьшенной копии и растянуть. До 06.09 копией был ВЕСЬ кадр,
 * ужатый до 380 px: лицо говорящей головы занимало на нём 6 % площади, а
 * тридцать с лишним проходов коробчатого фильтра шли по всем 100 % — замер
 * на реальной съёмке 640×480: 162 мс из 233 на кадр уходили в разбор.
 * Хуже того, радиусы пола считались от размера КАДРА: у маленького лица
 * радиус выходил больше самого лица, и «пол кожи» вырождался в среднее по
 * лицу. Теперь копия — это область вокруг лица (рамка + 28 % запаса), ужатая
 * до тех же 380 px: у крупного портрета это тот же кадр, что и раньше, у
 * говорящей головы — впятеро меньше пикселей И радиусы в масштабе лица, а
 * маленькое лицо разбирается в родных пикселях вместо 30-пиксельной копии.
 *
 * ТРЕТЬЕ — ЛИЦО ИЩЕТСЯ ЛЕСТНИЦЕЙ, А НЕ ОДНИМ ПРОХОДОМ (06.09.2026).
 * Детектор MediaPipe приводит вход к своему фиксированному размеру, поэтому
 * решает не размер кадра, а ДОЛЯ кадра, которую занимает лицо: замер на
 * реальной съёмке — лицо в 7 % ширины вертикального кадра не находилось ни
 * при 300, ни при 1024 px по длинной стороне (0/16), а в окне-плитке —
 * 16/16. В проде 6 из 10 разборов сцены заканчивались «лицо не найдено»,
 * и все — на вертикальных роликах с телефона. Лестница за один кадр:
 *   1. окно вокруг прошлой рамки (слежение) — из исходного разрешения;
 *   2. весь кадр;
 *   3. плитки (та же сетка, что у фото — FRFind.grid), не на каждом кадре.
 */
(function (root) {
    'use strict';

    var DEFAULT_WORK = 380;     // длинная сторона области разбора
    var DETECT_MAX = 380;       // длинная сторона входа детектора
    var TRACK_PAD = 2.2;        // окно слежения: во сколько раз шире рамки лица
    var HOLD_FRAMES = 6;        // сколько кадров помнить окно после потери лица
    var RELOCATE_BASE = 4;      // потерянное лицо: первая попытка плитками — на 4-м кадре,
    var RELOCATE_MAX = 32;      // дальше вдвое реже, не реже чем раз в 32 кадра
    var REGION_PAD = 0.28;      // запас области разбора вокруг рамки (доля рамки)
    var GAP_BRIDGE = 8;         // провал детектора ≤ N кадров закрывается интерполяцией
    var RAMP = 6;               // огибающая эффекта на краю провала, кадров
    var TILE_MIN_PX = 160;      // окно поиска уже этого по узкой стороне не пробуется
    var SCAN_EVERY = 12;        // «все лица»: полный кадр раз в N кадров — заметить новое лицо
    var MIN_TRACK = 3;          // дорожка короче стольких находок — отклик на фон, а не лицо

    function median(arr) {
        if (!arr.length) return 0;
        var a = arr.slice().sort(function (x, y) { return x - y; });
        var m = a.length >> 1;
        return a.length % 2 ? a[m] : (a[m - 1] + a[m]) / 2;
    }

    function srcSize(source) {
        return {
            w: source.videoWidth || source.displayWidth || source.width,
            h: source.videoHeight || source.displayHeight || source.height,
        };
    }

    // ── Геометрия лиц: перевод координат ─────────────────────────────────────
    /** Копия лиц с точками и контурами, пропущенными через fn(x,y)→[x,y]. */
    function mapFaces(faces, fn) {
        var out = new Array(faces.length);
        for (var i = 0; i < faces.length; i++) {
            var f = faces[i], g = {};
            for (var key in f) if (Object.prototype.hasOwnProperty.call(f, key)) g[key] = f[key];
            g.pts = f.pts ? f.pts.map(function (p) { var q = fn(p.x, p.y); return { x: q[0], y: q[1], z: p.z }; }) : f.pts;
            var poly = function (pg) { return pg ? pg.map(function (p) { return fn(p[0], p[1]); }) : pg; };
            g.oval = poly(f.oval); g.leftEye = poly(f.leftEye); g.rightEye = poly(f.rightEye);
            g.lips = poly(f.lips); g.mouthOpen = poly(f.mouthOpen);
            g.leftBrow = poly(f.leftBrow); g.rightBrow = poly(f.rightBrow);
            var a = fn(f.box.x, f.box.y), b = fn(f.box.x + f.box.w, f.box.y + f.box.h);
            g.box = { x: Math.min(a[0], b[0]), y: Math.min(a[1], b[1]), w: Math.abs(b[0] - a[0]), h: Math.abs(b[1] - a[1]) };
            out[i] = g;
        }
        return out;
    }

    function biggest(faces) {
        var b = faces[0];
        for (var i = 1; i < faces.length; i++) {
            if (faces[i].box.w * faces[i].box.h > b.box.w * b.box.h) b = faces[i];
        }
        return b;
    }

    /** Рамка всех лиц с запасом (доли кадра). */
    function faceBox(faces) {
        var x0 = 1, y0 = 1, x1 = 0, y1 = 0;
        for (var i = 0; i < faces.length; i++) {
            var b = faces[i].box;
            if (b.x < x0) x0 = b.x;
            if (b.y < y0) y0 = b.y;
            if (b.x + b.w > x1) x1 = b.x + b.w;
            if (b.y + b.h > y1) y1 = b.y + b.h;
        }
        var pw = (x1 - x0) * 0.22, ph = (y1 - y0) * 0.22;
        return { x: x0 - pw, y: y0 - ph, w: (x1 - x0) + 2 * pw, h: (y1 - y0) + 2 * ph };
    }

    /**
     * Область разбора: рамка всех лиц + REGION_PAD, в ПИКСЕЛЯХ источника
     * (srcW×srcH), целая и обрезанная кадром. Запас не декоративен: маска
     * растушёвана, а частотное разделение берёт окрестность радиусом до 10 %
     * ширины лица — без запаса у края области появился бы шов.
     */
    function regionOf(faces, srcW, srcH) {
        var bx0 = 1, by0 = 1, bx1 = 0, by1 = 0;
        for (var fi = 0; fi < faces.length; fi++) {
            var bb = faces[fi].box;
            if (bb.x < bx0) bx0 = bb.x;
            if (bb.y < by0) by0 = bb.y;
            if (bb.x + bb.w > bx1) bx1 = bb.x + bb.w;
            if (bb.y + bb.h > by1) by1 = bb.y + bb.h;
        }
        var pw = (bx1 - bx0) * REGION_PAD, ph = (by1 - by0) * REGION_PAD;
        var rx0 = Math.max(0, Math.floor((bx0 - pw) * srcW));
        var ry0 = Math.max(0, Math.floor((by0 - ph) * srcH));
        var rx1 = Math.min(srcW, Math.ceil((bx1 + pw) * srcW));
        var ry1 = Math.min(srcH, Math.ceil((by1 + ph) * srcH));
        return { x: rx0, y: ry0, w: Math.max(2, rx1 - rx0), h: Math.max(2, ry1 - ry0) };
    }

    // ── Холсты-черновики ─────────────────────────────────────────────────────
    // Переиспользуются: новый холст на каждый кадр — мусор для сборщика ровно
    // там, где считаются миллисекунды.
    function scratch(slot, w, h) {
        var c = scratch[slot] || (scratch[slot] = document.createElement('canvas'));
        if (c.width !== w || c.height !== h) { c.width = w; c.height = h; }
        return { canvas: c, ctx: c.getContext('2d', { willReadFrequently: true }), w: w, h: h };
    }

    /** Весь кадр, ужатый до maxSide по длинной стороне. */
    function downscale(source, maxSide) {
        var s = srcSize(source);
        var k = Math.min(1, maxSide / Math.max(s.w, s.h));
        var w = Math.max(1, Math.round(s.w * k)), h = Math.max(1, Math.round(s.h * k));
        var sc = scratch('down', w, h);
        sc.ctx.drawImage(source, 0, 0, w, h);
        return sc;
    }

    /** Окно rect (пиксели источника), ужатое до maxSide по длинной стороне. */
    function cropScaled(source, rect, maxSide, slot) {
        var k = Math.min(1, maxSide / Math.max(rect.w, rect.h));
        var w = Math.max(1, Math.round(rect.w * k)), h = Math.max(1, Math.round(rect.h * k));
        var sc = scratch(slot || 'crop', w, h);
        sc.ctx.drawImage(source, rect.x, rect.y, rect.w, rect.h, 0, 0, w, h);
        return sc;
    }

    // ── Поиск лица на кадре: слежение → весь кадр → плитки ──────────────────
    /**
     * @param {object} o {track:boolean — следить окном за каждым найденным
     *                    лицом (по умолчанию да), maxFaces — сколько лиц вести
     *                    (1 — только главное), deep:'never'|'lost'|'always' —
     *                    плитки никогда / когда лиц нет (по расписанию) / на
     *                    каждом кадре}
     *
     * СЛЕЖЕНИЕ ОКНОМ — У КАЖДОГО ЛИЦА И В ЛЮБОМ РЕЖИМЕ (15.10.2026). Прежде окно
     * работало только при «только главное лицо», а эта галочка по умолчанию
     * снята — и экспорт искал лицо по ВСЕМУ кадру, ужатому до 380 px. Детектор
     * решает по доле кадра, которую занимает лицо, и на вертикальном ролике
     * лицо в пятую часть ширины для него на пороге: на проде у роликов без окна
     * детектор находил лицо в 3–90 % кадров (жалоба #10001060: 1080×1920,
     * 70 %, 9329 кадров из 34 560 «дорисованы» интерполяцией), а у роликов с
     * окном — в 98–100 %. Пропуски закрывались мостами и огибающей: ретушь
     * ехала по интерполированной геометрии и гасла/включалась — это и было
     * «мерцание, когда человек двигается».
     * Полный кадр теперь нужен только чтобы ЗАМЕТИТЬ новое лицо: в режиме
     * «все лица» — раз в SCAN_EVERY кадров и когда какое-то лицо потерялось.
     *
     * Синхронный: детектор MediaPipe синхронный, а вызывающий может стоять
     * внутри синхронного draw() конвейера. Смерть wasm вылетает наружу как
     * есть — лечит её вызывающий через FRLandmarks.recover() (см. locate()).
     */
    function createFinder(o) {
        o = o || {};
        var deep = o.deep || 'lost';
        var track = o.track !== false;
        var maxFaces = Math.max(1, o.maxFaces || 4);
        // Длинная сторона входа детектора. 380 хватает ретуши (контур лица),
        // а исправлению взгляда нужна точность радужки: окно слежения вдвое
        // шире лица, и при 380 лицо попадало в модель ~170 px — меньше её
        // собственного входа 256 (/eye-contact просит 640).
        var detectMax = o.detectMax || DETECT_MAX;
        // tracks — лица, за которыми следим окном: {box, lost}, крупное первым.
        var mem = { tracks: [], sinceTiles: 1e9, tileEvery: RELOCATE_BASE, sinceScan: 0 };
        var stats = { track: 0, trackHits: 0, full: 0, tiles: 0, tileHits: 0 };

        function probeRect(src, W, H, rect, slot) {
            var sc = cropScaled(src, rect, detectMax, slot);
            var faces = root.FRLandmarks.detectSync(sc.canvas, sc.w, sc.h, {});
            if (!faces.length) return faces;
            return mapFaces(faces, function (x, y) {
                return [(rect.x + x * rect.w) / W, (rect.y + y * rect.h) / H];
            });
        }

        function windowAround(box, W, H) {
            var side = Math.max(box.w * W, box.h * H) * TRACK_PAD;
            var cx = (box.x + box.w / 2) * W, cy = (box.y + box.h / 2) * H;
            var x0 = Math.max(0, Math.round(cx - side / 2)), y0 = Math.max(0, Math.round(cy - side / 2));
            var x1 = Math.min(W, Math.round(cx + side / 2)), y1 = Math.min(H, Math.round(cy + side / 2));
            return { x: x0, y: y0, w: Math.max(2, x1 - x0), h: Math.max(2, y1 - y0) };
        }

        function tiles(src, W, H) {
            var F = root.FRFind, found = [];
            if (!F || !F.grid) {
                // Без find-face.js плитки молча не работают — а «молча» здесь
                // значит «лицо не найдено» у каждого вертикального ролика.
                if (!tiles.warned) { tiles.warned = true; try { console.warn('[FRVideo] FRFind не загружен — поиск лица окнами недоступен'); root.__ae && root.__ae('tool_diagnostic', { issue: 'frfind_missing' }); } catch (_) { } }
                return found;
            }
            // Лестница окон: половина кадра, треть, пятая часть. Решает доля
            // лица в ОКНЕ, а не пиксели: лицо в 7 % ширины вертикального кадра
            // в половинном окне остаётся 7.8 % его длинной стороны — на самом
            // полу детектора (замер 06.09: 0/16), в окне-трети — 12 % (16/16).
            // Окно короче TILE_MIN_PX по узкой стороне не пробуем: там лицо
            // было бы меньше 16 px, и детектору смотреть не на что.
            var scales = [[0.5, 0.5], [0.32, 0.55], [0.22, 0.6]];
            for (var p = 0; p < scales.length && !found.length; p++) {
                if (Math.min(W, H) * scales[p][0] < TILE_MIN_PX) break;
                var plan = F.grid(W, H, scales[p][0], scales[p][1]);
                for (var i = 0; i < plan.length; i++) {
                    stats.tiles++;
                    var got = probeRect(src, W, H, plan[i], 'tile');
                    if (got.length) F.merge(found, got);
                }
            }
            if (found.length) stats.tileHits++;
            return found;
        }

        /**
         * Из находок в окне — то лицо, ради которого окно ставили: больше всех
         * перекрывает прошлую рамку. Остальные находки окна (соседнее лицо, двое
         * в кадре рядом) — тоже лица кадра, их берёт find(): предпросмотр сеет
         * поиск ОБЩЕЙ рамкой всех лиц, и окно вокруг неё видит обоих.
         */
        function pickIn(got, box) {
            var best = null, bestIou = 0.05;
            for (var i = 0; i < got.length; i++) {
                var v = iou(got[i].box, box);
                if (v > bestIou) { bestIou = v; best = got[i]; }
            }
            return best;
        }

        function dupIn(list, f) {
            for (var i = 0; i < list.length; i++) if (iou(list[i].box, f.box) > 0.35) return true;
            return false;
        }

        /** Дорожки ← находки кадра: та же рамка (по перекрытию) или новое лицо. */
        function retrack(faces) {
            var next = [], used = new Array(mem.tracks.length);
            for (var i = 0; i < faces.length; i++) {
                var bi = -1, bv = 0.2;
                for (var j = 0; j < mem.tracks.length; j++) {
                    if (used[j]) continue;
                    var v = iou(mem.tracks[j].box, faces[i].box);
                    if (v > bv) { bv = v; bi = j; }
                }
                if (bi >= 0) used[bi] = true;
                next.push({ box: faces[i].box, lost: 0 });
            }
            for (var k = 0; k < mem.tracks.length; k++) {
                if (used[k]) continue;
                var tr = mem.tracks[k];
                if (++tr.lost <= HOLD_FRAMES) next.push(tr);
            }
            // Найденные — вперёд потерянных: потерянное лицо не должно
            // вытеснить найденное, когда следим за одним.
            next.sort(function (a, b) { return (a.lost > 0) - (b.lost > 0) || b.box.w * b.box.h - a.box.w * a.box.h; });
            mem.tracks = next.slice(0, maxFaces);
        }

        return {
            /** Лица в долях кадра; пусто — лица нет (на этом кадре). */
            find: function (src, W, H) {
                var faces = [], expected = 0;
                if (track) {
                    for (var t = 0; t < mem.tracks.length; t++) {
                        expected++;
                        stats.track++;
                        var tb = mem.tracks[t].box;
                        var inWin = probeRect(src, W, H, windowAround(tb, W, H), 'track');
                        var got = pickIn(inWin, tb);
                        if (got && !dupIn(faces, got)) { faces.push(got); stats.trackHits++; }
                        if (maxFaces > 1) for (var g = 0; g < inWin.length; g++) if (inWin[g] !== got && !dupIn(faces, inWin[g])) faces.push(inWin[g]);
                    }
                }
                // Полный кадр: лиц нет вовсе — или (режим «все лица») пора
                // посмотреть, не появилось ли новое, или кто-то потерялся.
                if (!faces.length || (maxFaces > 1 && (faces.length < expected || ++mem.sinceScan >= SCAN_EVERY))) {
                    mem.sinceScan = 0;
                    stats.full++;
                    var all = probeRect(src, W, H, { x: 0, y: 0, w: W, h: H }, 'full');
                    for (var a = 0; a < all.length; a++) if (!dupIn(faces, all[a])) faces.push(all[a]);
                }
                if (!faces.length && deep !== 'never') {
                    mem.sinceTiles++;
                    if (deep === 'always' || mem.sinceTiles >= mem.tileEvery) {
                        mem.sinceTiles = 0;
                        faces = tiles(src, W, H);
                        // Пустой кадр за пустым кадром: плитки дорожают вдвое
                        // на каждую неудачу, чтобы ролик без лица не стоил
                        // втрое дороже ролика с лицом.
                        mem.tileEvery = faces.length ? RELOCATE_BASE : Math.min(RELOCATE_MAX, mem.tileEvery * 2);
                    }
                }
                if (faces.length) mem.tileEvery = RELOCATE_BASE;
                if (track) retrack(faces);
                return faces;
            },
            /** Подсказать, где лицо было (предпросмотр после перемотки). */
            seed: function (box) { if (box) mem.tracks = [{ box: box, lost: 0 }]; },
            reset: function () { mem.tracks = []; mem.sinceTiles = 1e9; mem.sinceScan = 0; mem.tileEvery = RELOCATE_BASE; },
            stats: stats,
        };
    }

    /** find() с лечением смерти wasm: следующий кандидат и ОДИН повтор. */
    async function locate(finder, src, W, H) {
        try { return finder.find(src, W, H); }
        catch (e) {
            await root.FRLandmarks.recover(e);
            return finder.find(src, W, H);
        }
    }

    /**
     * Снять параметры сцены по выборке кадров.
     * @param {function} grab  (timeSec) => Promise<canvas|video>  — выдать кадр
     * @param {object}   o     {duration, samples, sources, workMax, mainFaceOnly, onProgress}
     */
    async function prepare(grab, o) {
        o = o || {};
        var samples = o.samples || 7;
        var workMax = o.workMax || DEFAULT_WORK;
        var dur = o.duration || 0;

        // IMAGE-режим: выборка идёт с шагом в секунды, слежению между такими
        // кадрами вести нечего, а VIDEO-режим у MediaPipe несёт скрытое
        // состояние и требование монотонных меток, на котором уже ломались.
        await root.FRLandmarks.ensure(o.sources || [], { numFaces: o.numFaces || 4, mode: 'IMAGE' });
        // Каждая выборка ищется независимо и С плитками: разбор сцены — это
        // тот самый момент, когда мы решаем «лицо есть / лица нет», и здесь
        // дорогой поиск оправдан пять раз, а не на каждом кадре.
        var finder = createFinder({ track: false, deep: 'always' });

        var Ls = [[], [], []], widths = [], seen = 0, framesWithFace = 0, confident = 0;
        var perSample = [];
        for (var i = 0; i < samples; i++) {
            // Первый и последний кадр не берём: у роликов там часто заставка
            // или затемнение, и оценка света по ним не про сцену.
            var t = dur * (i + 1) / (samples + 1);
            var cv;
            try { cv = await grab(t); } catch (_) { continue; }
            if (!cv) continue;
            seen++;
            var s = srcSize(cv);
            var faces = await locate(finder, cv, s.w, s.h);
            // Что именно видел детектор — в телеметрию: чёрный кадр после
            // перемотки (Safari) неотличим от «лица нет» без этой строки.
            perSample.push({ t: +t.toFixed(2), faces: faces.length, luma: sampleLuma(cv) });
            if (!faces.length) continue;
            framesWithFace++;
            var ac = analysisCrop(cv, s.w, s.h, faces, workMax);
            var planes = root.FREngine.toPlanes(ac.small.ctx.getImageData(0, 0, ac.small.w, ac.small.h));
            var m = root.FREngine.analyze(planes, ac.faces, { faceWidth: faces[0].box.w * s.w / ac.region.w, robustPasses: 1 });
            if (!m || !m.ok || !m.light) continue;
            // В медиану идут ВСЕ оценки, включая притянутые к нейтрали.
            // Требование «только уверенные» проверено и отвергнуто: на живом
            // ролике ни один из семи кадров не дал уверенной оценки (оценщик
            // систематически смещён в синеву и упирается в проверку
            // правдоподобия), выборка выходила пустой, и свет всегда падал в
            // нейтраль. Притянутая оценка — это уже смесь измерения с
            // нейтралью, то есть осмысленное число, а не мусор; медиана по
            // ним устойчива к одиночному пересвеченному кадру.
            Ls[0].push(m.light.L[0]); Ls[1].push(m.light.L[1]); Ls[2].push(m.light.L[2]);
            if (m.light.confident) confident++;
            widths.push(biggest(faces).box.w);
            if (o.onProgress) o.onProgress((i + 1) / samples);
        }

        var light;
        if (Ls[0].length >= 2) {
            var L = [median(Ls[0]), median(Ls[1]), median(Ls[2])];
            var sL = L[0] + L[1] + L[2];
            light = { L: [L[0] / sL, L[1] / sL, L[2] / sL], confident: confident > 0, n: Ls[0].length, nConfident: confident, via: 'clip-median' };
        } else {
            light = { L: [1 / 3, 1 / 3, 1 / 3], confident: false, n: Ls[0].length, via: 'clip-fallback' };
        }

        return {
            ok: framesWithFace > 0,
            light: light,
            faceWidth: widths.length ? median(widths) : 0.3,
            framesSampled: seen,
            framesWithFace: framesWithFace,
            faceCoverage: seen ? framesWithFace / seen : 0,
            workMax: workMax,
            samples: perSample,
            finderStats: finder.stats,
        };
    }

    /** Средняя яркость кадра по крошечной копии — диагностика «что видел детектор». */
    function sampleLuma(source) {
        try {
            var sc = scratch('luma', 16, 16);
            sc.ctx.drawImage(source, 0, 0, 16, 16);
            var d = sc.ctx.getImageData(0, 0, 16, 16).data, sum = 0;
            for (var i = 0; i < d.length; i += 4) sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
            return Math.round(sum / (d.length / 4));
        } catch (_) { return -1; }
    }

    /**
     * Область лица из источника → маленькая копия для разбора + лица в долях
     * ОБЛАСТИ. Один код на разбор сцены и на кадровый проход: свет, измеренный
     * при подготовке, обязан быть измерен на том же, на чём потом считается кадр.
     */
    function analysisCrop(source, srcW, srcH, faces, workMax) {
        var region = regionOf(faces, srcW, srcH);
        var small = cropScaled(source, region, workMax || DEFAULT_WORK, 'analysis');
        var rfaces = mapFaces(faces, function (x, y) {
            return [(x * srcW - region.x) / region.w, (y * srcH - region.y) / region.h];
        });
        return { region: region, small: small, faces: rfaces };
    }


    // ── Система координат ЛИЦА ──────────────────────────────────────────────
    // Квадратная сетка FACE_GRID×FACE_GRID, натянутая на рамку лица с запасом.
    // В ней «лоб» остаётся лбом независимо от того, куда лицо уехало в кадре.
    var FACE_GRID = 48;
    // Пол кожи сглаживается во времени на более частой сетке: он несёт
    // светотень лица (нос, скулы), и поправка обязана быть мельче неё.
    var FLOOR_GRID = 96;

    function toFaceSpace(field, w, h, fb, g) {
        var out = new Float32Array(g * g);
        for (var j = 0; j < g; j++) {
            var fy = (fb.y + (j + 0.5) / g * fb.h) * h;
            var y = Math.max(0, Math.min(h - 1, Math.round(fy)));
            for (var i = 0; i < g; i++) {
                var fx = (fb.x + (i + 0.5) / g * fb.w) * w;
                var x = Math.max(0, Math.min(w - 1, Math.round(fx)));
                out[j * g + i] = field[y * w + x];
            }
        }
        return out;
    }

    function fromFaceSpace(grid, g, field, w, h, fb, add) {
        var x0 = fb.x * w, y0 = fb.y * h, bw = fb.w * w, bh = fb.h * h;
        for (var y = 0; y < h; y++) {
            var v = (y - y0) / bh * g - 0.5;
            if (v < 0 || v > g - 1) continue;
            var j0 = Math.floor(v), tj = v - j0, j1 = Math.min(g - 1, j0 + 1);
            for (var x = 0; x < w; x++) {
                var u = (x - x0) / bw * g - 0.5;
                if (u < 0 || u > g - 1) continue;
                var i0 = Math.floor(u), ti = u - i0, i1 = Math.min(g - 1, i0 + 1);
                var a = grid[j0 * g + i0] + (grid[j0 * g + i1] - grid[j0 * g + i0]) * ti;
                var b = grid[j1 * g + i0] + (grid[j1 * g + i1] - grid[j1 * g + i0]) * ti;
                if (add) field[y * w + x] += a + (b - a) * tj;
                else field[y * w + x] = a + (b - a) * tj;
            }
        }
    }


    /**
     * Сглаживание ГЕОМЕТРИИ во времени (причинное — для предпросмотра и
     * запасного покадрового прохода).
     *
     * Детектор выдаёт лендмарки с дрожанием в доли процента кадра — на
     * неподвижном лице контур всё равно «дышит». Маска строится по контуру,
     * поэтому её край дрожит вместе с ним, а вместе с краем дрожит и эффект.
     * Никакое сглаживание поля блика этого не лечит: источник дрожания стоит
     * ВЫШЕ по цепочке.
     *
     * Смешиваем точки с предыдущим кадром, но НЕ безусловно: если точка уехала
     * дальше порога, значит лицо реально двинулось — там сглаживание надо
     * отпустить, иначе маска будет отставать от лица (и это заметно сильнее,
     * чем дрожь).
     */
    function smoothFaces(prev, cur, alpha, snapDist) {
        if (!prev || prev.length !== cur.length) return cur;
        for (var f = 0; f < cur.length; f++) {
            var a = prev[f], b = cur[f];
            if (!a || !a.pts || !b.pts || a.pts.length !== b.pts.length) continue;
            for (var i = 0; i < b.pts.length; i++) {
                var dx = b.pts[i].x - a.pts[i].x, dy = b.pts[i].y - a.pts[i].y;
                var d = Math.sqrt(dx * dx + dy * dy);
                var k = d > snapDist ? 0 : alpha * (1 - d / snapDist);
                b.pts[i] = { x: b.pts[i].x - dx * k, y: b.pts[i].y - dy * k, z: b.pts[i].z };
            }
        }
        return cur;
    }

    /** Пересобрать контуры из сглаженных точек. */
    function rebuildPolys(faces) {
        var R = root.FRLandmarks.rings();
        if (!R) return faces;
        var pick = function (pts, ring) {
            if (!ring) return null;
            var o = new Array(ring.length);
            for (var i = 0; i < ring.length; i++) { var p = pts[ring[i]]; o[i] = p ? [p.x, p.y] : [0, 0]; }
            return o;
        };
        for (var f = 0; f < faces.length; f++) {
            var pts = faces[f].pts;
            faces[f].oval = pick(pts, R.oval);
            faces[f].leftEye = pick(pts, R.leftEye);
            faces[f].rightEye = pick(pts, R.rightEye);
            faces[f].lips = pick(pts, root.FRLandmarks.OUTER_LIP || R.lips);
            faces[f].leftBrow = pick(pts, R.leftBrow);
            faces[f].rightBrow = pick(pts, R.rightBrow);
            faces[f].mouthOpen = pick(pts, root.FRLandmarks.INNER_LIP || null) || faces[f].mouthOpen;
            var minX = 1, minY = 1, maxX = 0, maxY = 0;
            for (var j = 0; j < pts.length; j++) {
                if (pts[j].x < minX) minX = pts[j].x;
                if (pts[j].y < minY) minY = pts[j].y;
                if (pts[j].x > maxX) maxX = pts[j].x;
                if (pts[j].y > maxY) maxY = pts[j].y;
            }
            faces[f].box = { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
        }
        return faces;
    }

    // ── Дорожка лица по всему ролику (проход 1 экспорта) ─────────────────────
    /**
     * Накопитель геометрии по кадрам. push() на каждом кадре в порядке показа,
     * finish() — дорожка с ЗАГЛЯДЫВАНИЕМ ВПЕРЁД, которого покадровый проход
     * дать не может:
     *   · провалы детектора ≤ GAP_BRIDGE кадров закрываются интерполяцией точек
     *     между соседними находками того же лица (по пересечению рамок);
     *   · точки сглаживаются симметрично по трём кадрам с тем же порогом
     *     «реальное движение — не сглаживать»;
     *   · у краёв длинного провала эффект гасится огибающей за RAMP кадров:
     *     ретушь, которая включается и выключается за один кадр, видна как
     *     вспышка, а кадры без лица остаются как есть.
     */
    function createTracker(o) {
        o = o || {};
        var finder = createFinder({ maxFaces: o.mainFaceOnly ? 1 : 4, deep: 'lost' });
        var frames = [];
        return {
            push: function (src, W, H, t) {
                var faces = finder.find(src, W, H);
                frames.push({ t: t, faces: faces });
                return faces;
            },
            finish: function () { return finishTrack(frames, o); },
            finder: finder,
            count: function () { return frames.length; },
        };
    }

    function iou(a, b) {
        var x1 = Math.max(a.x, b.x), y1 = Math.max(a.y, b.y);
        var x2 = Math.min(a.x + a.w, b.x + b.w), y2 = Math.min(a.y + a.h, b.y + b.h);
        if (x2 <= x1 || y2 <= y1) return 0;
        var inter = (x2 - x1) * (y2 - y1);
        return inter / (a.w * a.h + b.w * b.h - inter);
    }

    function lerpFace(a, b, t) {
        var g = {};
        for (var key in a) if (Object.prototype.hasOwnProperty.call(a, key)) g[key] = a[key];
        g.pts = a.pts.map(function (p, i) {
            var q = b.pts[i] || p;
            return { x: p.x + (q.x - p.x) * t, y: p.y + (q.y - p.y) * t, z: p.z };
        });
        g.bridged = true;
        return g;
    }

    /**
     * Дорожки ЛИЦ (15.10.2026): находка кадра продолжает ту дорожку, чья
     * последняя рамка (не дальше GAP_BRIDGE кадров назад) больше всех с ней
     * перекрывается; иначе — новое лицо. Прежде дорожка была одна: «самое
     * крупное лицо кадра», — и у двоих в кадре она перескакивала с лица на
     * лицо, а остальные лица шли без мостов, сглаживания и огибающей, то есть
     * мигали вместе с каждым промахом детектора.
     */
    function faceTracks(frames) {
        var n = frames.length, tracks = [];
        for (var i = 0; i < n; i++) {
            var fs = frames[i].faces, pairs = [];
            for (var t = 0; t < tracks.length; t++) {
                var tr = tracks[t];
                if (i - tr.last > GAP_BRIDGE + 1) continue;
                for (var f = 0; f < fs.length; f++) {
                    var v = iou(tr.at[tr.last].box, fs[f].box);
                    if (v >= 0.3) pairs.push([v, t, f]);
                }
            }
            pairs.sort(function (x, y) { return y[0] - x[0]; });
            var tUsed = {}, fUsed = {};
            for (var p = 0; p < pairs.length; p++) {
                var pp = pairs[p];
                if (tUsed[pp[1]] || fUsed[pp[2]]) continue;
                tUsed[pp[1]] = fUsed[pp[2]] = true;
                tracks[pp[1]].at[i] = fs[pp[2]];
                tracks[pp[1]].last = i;
            }
            for (var f2 = 0; f2 < fs.length; f2++) {
                if (fUsed[f2]) continue;
                var nt = { at: [], first: i, last: i };
                nt.at[i] = fs[f2];
                tracks.push(nt);
            }
        }
        return tracks;
    }

    /** Мосты через короткие провалы ВНУТРИ дорожки: интерполяция точек. */
    function bridgeTrack(tr) {
        var seq = tr.at, bridged = 0;
        for (var s = tr.first + 1; s <= tr.last; s++) {
            if (seq[s] || !seq[s - 1]) continue;
            var e = s;
            while (!seq[e]) e++;                    // e ≤ last: конец дорожки — находка
            var gap = e - s, a = seq[s - 1], b = seq[e];
            if (gap <= GAP_BRIDGE && a.pts.length === b.pts.length && iou(a.box, b.box) >= 0.3) {
                for (var k = 0; k < gap; k++) seq[s + k] = lerpFace(a, b, (k + 1) / (gap + 1));
                bridged += gap;
            }
            s = e;
        }
        return bridged;
    }

    /** Симметричное сглаживание точек дорожки (новый массив; вход не меняется). */
    function smoothTrack(tr, alpha, snap) {
        var seq = tr.at, sm = [];
        for (var j = tr.first; j <= tr.last; j++) {
            var c = seq[j];
            if (!c) continue;
            var p = seq[j - 1] || null, q = seq[j + 1] || null;
            var same = function (x) { return x && x.pts.length === c.pts.length && iou(x.box, c.box) > 0.2; };
            p = same(p) ? p : null; q = same(q) ? q : null;
            if (!p && !q) { sm[j] = c; continue; }
            var g = {};
            for (var key in c) if (Object.prototype.hasOwnProperty.call(c, key)) g[key] = c[key];
            g.pts = c.pts.map(function (pt, idx) {
                var sx = pt.x, sy = pt.y, wsum = 1;
                var take = function (nb) {
                    if (!nb) return;
                    var dx = nb.pts[idx].x - pt.x, dy = nb.pts[idx].y - pt.y;
                    var d = Math.sqrt(dx * dx + dy * dy);
                    if (d > snap) return;                     // реальное движение — не сглаживать
                    var w = alpha * 0.5 * (1 - d / snap);
                    sx += nb.pts[idx].x * w; sy += nb.pts[idx].y * w; wsum += w;
                };
                take(p); take(q);
                return { x: sx / wsum, y: sy / wsum, z: pt.z };
            });
            sm[j] = g;
        }
        return sm;
    }

    function finishTrack(frames, o) {
        var n = frames.length;
        var rawWith = 0;
        for (var i = 0; i < n; i++) if (frames[i].faces.length) rawWith++;
        var snap = o.geometrySnap !== undefined ? o.geometrySnap : 0.02;
        var alpha = o.geometry !== undefined ? o.geometry : 0.6;
        // Дорожка из одной-двух находок — не лицо, а случайный отклик детектора
        // на фон: ретушь на ней — вспышка на пустом месте.
        var tracks = faceTracks(frames).filter(function (tr) {
            var hits = 0;
            for (var h = tr.first; h <= tr.last; h++) if (tr.at[h]) hits++;
            return hits >= Math.min(MIN_TRACK, n);
        }), bridged = 0;
        for (var t = 0; t < tracks.length; t++) {
            var tr = tracks[t];
            bridged += bridgeTrack(tr);
            tr.sm = smoothTrack(tr, alpha, snap);
            rebuildPolys(tr.sm.filter(function (x) { return !!x; }));
            // Вес дорожки — сколько лица она несёт за весь ролик: главное лицо
            // интервью — то, что крупно И долго, а не крупнее всех в кадре.
            tr.score = 0;
            for (var s = tr.first; s <= tr.last; s++) if (tr.sm[s]) tr.score += tr.sm[s].box.w * tr.sm[s].box.h;
        }
        tracks.sort(function (a, b) { return b.score - a.score; });
        // Какие лица кадра ретушируются: все — или (только главное) одно, с
        // наибольшим весом среди присутствующих: при смене плана главным
        // становится тот, кто в кадре, а у двоих в кадре выбор не скачет.
        var mainOnly = o.mainFaceOnly !== false;
        var on = tracks.map(function () { return []; }), withFace = 0;
        for (var r = 0; r < n; r++) {
            var any = false;
            for (var q = 0; q < tracks.length; q++) {
                if (!tracks[q].sm[r]) continue;
                on[q][r] = true; any = true;
                if (mainOnly) break;
            }
            if (any) withFace++;
        }
        // Огибающая у краёв участка, где лицо ретушируется (не у краёв ролика):
        // ретушь, которая включается и выключается за один кадр, видна как
        // вспышка, а кадры без лица остаются как есть.
        for (var u = 0; u < tracks.length; u++) {
            var sel = on[u], kk = tracks[u].k = [];
            for (var x = tracks[u].first; x <= tracks[u].last; x++) {
                if (!sel[x]) continue;
                var left = 1e9, right = 1e9;
                for (var d1 = 1; d1 <= RAMP; d1++) { if (x - d1 < 0) break; if (!sel[x - d1]) { left = d1; break; } }
                for (var d2 = 1; d2 <= RAMP; d2++) { if (x + d2 >= n) break; if (!sel[x + d2]) { right = d2; break; } }
                var d = Math.min(left, right);
                kk[x] = d > RAMP ? 1 : d / (RAMP + 1);
            }
        }
        return {
            n: n,
            covRaw: n ? rawWith / n : 0,
            cov: n ? withFace / n : 0,
            bridged: bridged,
            tracks: tracks.length,
            at: function (i) {
                if (i < 0 || i >= n) return { faces: [], k: 0 };
                // Первым идёт лицо с наибольшим весом — к нему привязаны пятна.
                // У каждого лица своя огибающая (f.k): лицо, входящее в кадр,
                // проявляется за RAMP кадров, пока соседнее ретушируется в полную
                // силу. Огибающая кадра — наибольшая; свою каждое лицо получает
                // в applyFrame.
                var out = [], k = 0;
                for (var q = 0; q < tracks.length; q++) {
                    if (!on[q][i]) continue;
                    var f = tracks[q].sm[i];
                    f.k = tracks[q].k[i];
                    f.tid = q;              // ключ памяти сглаживания лица
                    if (f.k > k) k = f.k;
                    out.push(f);
                }
                return { faces: out, k: out.length ? k : 0, t: frames[i].t };
            },
            timeAt: function (i) { return frames[i] ? frames[i].t : -1; },
            /** Индекс кадра, ближайшего по времени (двоичный поиск: кадры идут по порядку). */
            nearest: function (t) {
                var lo = 0, hi = n - 1;
                while (lo < hi) { var mid = (lo + hi) >> 1; if (frames[mid].t < t) lo = mid + 1; else hi = mid; }
                if (lo > 0 && Math.abs(frames[lo - 1].t - t) < Math.abs(frames[lo].t - t)) lo--;
                return lo;
            },
        };
    }

    // ── Кадр по фазам ────────────────────────────────────────────────────────
    // Один и тот же кадр считают два пути: подряд на главном потоке
    // (предпросмотр, запасной проход) и пулом воркеров (экспорт, createPool).
    // Чтобы они не разошлись ни в одном бите, путь у них ОДИН:
    //   takeFrame     — главный поток: вырезы для разбора (у каждого лица свой)
    //                   и пиксели общей области;
    //   analyzeFrame  — разбор каждого лица на малой сетке; чистая функция входа;
    //   temporalStep  — сглаживание во времени, в системе лица, у каждого лица
    //                   своё; ЕДИНСТВЕННОЕ состояние, идёт строго по порядку кадров;
    //   applyFrame    — всё на полном разрешении общей области; чистая функция.
    // Разбор и применение можно считать где угодно и в любом порядке, поэтому
    // пул раздаёт их воркерам, а сглаживание держит у себя.

    /**
     * Главный поток: всё, что нужно разбору и применению, — пиксели и числа.
     *
     * РАЗБОР — У КАЖДОГО ЛИЦА СВОЙ (15.10.2026). Прежде разбиралась одна
     * область вокруг ВСЕХ лиц, ужатая до 380 px: два лица по краям кадра —
     * и каждое разбиралось в половинном разрешении, с радиусами пола и блика
     * от общей области, а сетка сглаживания во времени растягивалась на обоих.
     * Замер (два интервью рядом, второе входит посреди ролика): в момент входа
     * второго лица правка ПЕРВОГО падала вдвое (0.52 → 0.24) — вспышка на лице,
     * которое никуда не двигалось. Теперь у каждого лица своя область, своя
     * малая копия и своя память сглаживания; правки — тоже в его области
     * (applyFrame). Общая область — рамка областей лиц; у одного лица его
     * область и есть общая — путь побитово прежний.
     */
    function takeFrame(scene, outCtx, faces, outW, outH) {
        var workMax = scene.workMax || DEFAULT_WORK;
        var parts = new Array(faces.length), x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
        for (var i = 0; i < faces.length; i++) {
            var ac = analysisCrop(outCtx.canvas, outW, outH, [faces[i]], workMax);
            var rg = ac.region;
            if (rg.x < x0) x0 = rg.x;
            if (rg.y < y0) y0 = rg.y;
            if (rg.x + rg.w > x1) x1 = rg.x + rg.w;
            if (rg.y + rg.h > y1) y1 = rg.y + rg.h;
            parts[i] = {
                small: ac.small.ctx.getImageData(0, 0, ac.small.w, ac.small.h),
                reg: ac.region,
                rface: ac.faces[0],
                // Ширина лица в долях ОБЛАСТИ, а не кадра: радиусы полос частот
                // считаются от неё, и подставить сюда долю кадра значит
                // промахнуться во столько раз, во сколько область меньше кадра.
                faceWidth: scene.faceWidth * outW / ac.region.w,
                // Чья это память сглаживания: дорожка лица (трекер экспорта) или
                // место в списке (предпросмотр — там память сбрасывается на кадре).
                key: faces[i].tid !== undefined ? faces[i].tid : i,
            };
        }
        // Общая область — рамка областей лиц: каждая лежит в ней целиком.
        var reg = { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
        return {
            parts: parts,
            region: outCtx.getImageData(reg.x, reg.y, reg.w, reg.h),
            reg: reg,
            rfaces: mapFaces(faces, function (x, y) { return [(x * outW - reg.x) / reg.w, (y * outH - reg.y) / reg.h]; }),
            faceWidth: scene.faceWidth * outW / reg.w,
        };
    }

    /** Разбор кадра: каждое лицо — в своей области (analyzePart). */
    function analyzeFrame(scene, job, opt) {
        var out = { ok: false, parts: new Array(job.parts.length) };
        for (var i = 0; i < job.parts.length; i++) {
            out.parts[i] = analyzePart(scene, job.parts[i], opt);
            if (out.parts[i].ok) out.ok = true;
        }
        return out;
    }

    /** Разбор лица на малой сетке: модель + поле блика (+ оно же в системе лица). */
    function analyzePart(scene, job, opt) {
        var sp = root.FREngine.toPlanes(job.small);
        var model = root.FREngine.analyze(sp, [job.rface], {
            faceWidth: job.faceWidth,
            light: scene.light,          // СЦЕНОВЫЙ свет, не покадровый
            // Уточняющие проходы нужны, чтобы отделить блик от кожи при
            // НЕизвестном свете. На видео свет уже измерен по всему
            // ролику, поэтому одного прохода достаточно, а каждый лишний
            // стоит полного перебора многомасштабного пола.
            robustPasses: opt.robustPasses,
        });
        if (!model.ok) return { ok: false, key: job.key };
        var spec = model.spec || (model.spec = root.FREngine.specularField(
            sp, model.mask, model.floor, scene.light.L, { capPlanes: model.smooth }));
        var fb = faceBox([job.rface]), reg = job.reg;
        var fgrid = null;
        if (opt.floorSmoothing > 0) {
            var fl = model.floor, G2 = FLOOR_GRID * FLOOR_GRID;
            fgrid = new Float32Array(4 * G2);
            fgrid.set(toFaceSpace(fl.R, sp.w, sp.h, fb, FLOOR_GRID), 0);
            fgrid.set(toFaceSpace(fl.G, sp.w, sp.h, fb, FLOOR_GRID), G2);
            fgrid.set(toFaceSpace(fl.B, sp.w, sp.h, fb, FLOOR_GRID), 2 * G2);
            fgrid.set(toFaceSpace(model.mask, sp.w, sp.h, fb, FLOOR_GRID), 3 * G2);
        }
        return {
            ok: true, key: job.key, model: model, spec: spec, fb: fb, sw: sp.w, sh: sp.h, reg: reg,
            // Поле блика переводится в нормированные координаты ЛИЦА: складывать
            // поля соседних кадров в координатах КАДРА нельзя — лицо движется, и
            // такое «сглаживание» смешивает лоб текущего кадра со щекой
            // предыдущего. В системе лица движение из сравнения уходит.
            grid: opt.smoothing > 0 ? toFaceSpace(spec, sp.w, sp.h, fb, FACE_GRID) : null,
            fgrid: fgrid,
            // Рамка лица в пикселях кадра — по ней сглаживание узнаёт, что
            // перед ним то же лицо, а не смена плана.
            box: { x: reg.x + fb.x * reg.w, y: reg.y + fb.y * reg.h, w: fb.w * reg.w, h: fb.h * reg.h },
        };
    }

    /**
     * Сглаживание во времени (в системе лица) — ЕДИНСТВЕННОЕ состояние между
     * кадрами. На входе — то, что разбор отдал наружу ({grid, fgrid, box}),
     * на выходе — что применить: {s: поле блика, f: поправка пола} (null —
     * применять нечего: первый кадр участка остаётся как есть и становится
     * памятью для следующего).
     *
     * ПОЛ КОЖИ (15.10.2026). Снятие блика упирается в предохранитель «не ниже
     * пола кожи» (deshine), а пол оценивается заново на каждом кадре по
     * «спокойным» пикселям, отобранным порогами, — и порог переключает
     * островки. Замер на живых интервью (docs/why/video-retouch-flicker.md):
     * сглаженное поле блика дрожит на 4–5 % своей величины, предохранитель —
     * на 10–15 %, и итог решает именно он в 73–83 % пикселей блика. То есть
     * сглаживалась величина, которая почти никогда не решает, а решающая
     * дрожала: блик то снимался, то проступал. Теперь сглаживается и пол —
     * ПОПРАВКОЙ на сетке лица (мелкая светотень текущего кадра остаётся), и
     * только в клетках, где кожа и сейчас, и была: вне маски «пол» — это
     * волосы и фон, их движение не должно доезжать до кожи.
     *
     * Память — у каждого лица своя (по ключу дорожки) и сбрасывается, когда
     * перед нами не то же лицо: был кадр без лиц (state.gap), лица не было в
     * прошлом кадре или его рамка скакнула (смена плана).
     *
     * pack — {parts: [{ok, key, grid, fgrid, box}]}; выход — {parts: [{s, f}|null]}
     * в том же порядке или null, если применять нечего ни у одного лица.
     */
    function temporalStep(state, pack, opt) {
        if (!pack || !pack.parts) return null;
        if (state.gap) state.faces = null;
        state.gap = false;
        var was = state.faces || {}, now = {}, out = { parts: new Array(pack.parts.length) }, any = false;
        for (var i = 0; i < pack.parts.length; i++) {
            var q = pack.parts[i];
            out.parts[i] = null;
            if (!q) continue;
            // Лицо, которое не разобралось (кожи не нашлось), памяти не меняет —
            // как кадр целиком в последовательном пути.
            if (!q.ok) { if (was[q.key]) now[q.key] = was[q.key]; continue; }
            var s = was[q.key] || {};
            out.parts[i] = stepFace(s, q, opt);
            now[q.key] = s;
            if (out.parts[i]) any = true;
        }
        state.faces = now;
        return any ? out : null;
    }

    function stepFace(state, pack, opt) {
        if (state.box && pack.box && iou(state.box, pack.box) < 0.3) {
            state.prev = null; state.fprev = null;
        }
        state.box = pack.box || null;
        var out = { s: null, f: null };
        var grid = pack.grid, smoothing = opt.smoothing;
        if (grid) {
            if (state.prev) {
                var prev = state.prev;
                for (var i = 0; i < grid.length; i++) grid[i] = prev[i] * smoothing + grid[i] * (1 - smoothing);
                out.s = grid;
            }
            state.prev = grid;
        }
        var fg = pack.fgrid;
        if (fg) {
            var G2 = FLOOR_GRID * FLOOR_GRID, a = opt.floorSmoothing, fp = state.fprev;
            if (fp) {
                var corr = new Float32Array(3 * G2), ema = new Float32Array(4 * G2);
                for (var c = 0; c < G2; c++) {
                    var inside = fg[3 * G2 + c] > 0.5 && fp[3 * G2 + c] > 0.5;
                    ema[3 * G2 + c] = fg[3 * G2 + c];
                    for (var ch = 0; ch < 3; ch++) {
                        var q = ch * G2 + c, cur = fg[q];
                        var v = inside ? fp[q] * a + cur * (1 - a) : cur;
                        ema[q] = v;
                        corr[q] = v - cur;
                    }
                }
                state.fprev = ema;
                out.f = corr;
            } else {
                state.fprev = fg;
            }
        }
        return out.s || out.f ? out : null;
    }

    /**
     * «Что правится»: сколько изменила группа правок в каждом пикселе области
     * лица — сумма |ΔR|+|ΔG|+|ΔB| в линейном свете, по стадиям группы.
     */
    function addDelta(a, b, acc) {
        for (var i = 0; i < acc.length; i++) {
            acc[i] += Math.abs(a.R[i] - b.R[i]) + Math.abs(a.G[i] - b.G[i]) + Math.abs(a.B[i] - b.B[i]);
        }
    }

    /** Вырез прямоугольника плоскостей (новые массивы). */
    function cropPlanes(pl, x0, y0, w, h) {
        var n = w * h;
        var out = { w: w, h: h, R: new Float32Array(n), G: new Float32Array(n), B: new Float32Array(n), clip: new Uint8Array(n) };
        for (var y = 0; y < h; y++) {
            var s = (y + y0) * pl.w + x0, d = y * w;
            out.R.set(pl.R.subarray(s, s + w), d); out.G.set(pl.G.subarray(s, s + w), d);
            out.B.set(pl.B.subarray(s, s + w), d); out.clip.set(pl.clip.subarray(s, s + w), d);
        }
        return out;
    }

    function pastePlanes(dst, src, x0, y0) {
        for (var y = 0; y < src.h; y++) {
            var s = y * src.w, d = (y + y0) * dst.w + x0;
            dst.R.set(src.R.subarray(s, s + src.w), d); dst.G.set(src.G.subarray(s, s + src.w), d);
            dst.B.set(src.B.subarray(s, s + src.w), d);
        }
    }

    /** addDelta для выреза, сложенный в карту общей области со сдвигом. */
    function addDeltaAt(a, b, acc, accW, x0, y0) {
        for (var y = 0; y < a.h; y++) {
            for (var x = 0; x < a.w; x++) {
                var i = y * a.w + x;
                acc[(y + y0) * accW + x + x0] += Math.abs(a.R[i] - b.R[i]) + Math.abs(a.G[i] - b.G[i]) + Math.abs(a.B[i] - b.B[i]);
            }
        }
    }

    /**
     * Полное разрешение ТОЛЬКО ВОКРУГ ЛИЦ. Пишет результат в job.region.
     * `explain` — только для кадра предпросмотра: вдобавок отдать карты того,
     * что изменила каждая группа правок (блеск, кожа, глаза и зубы). Экспорт и
     * пул воркеров его не передают — их выдача от флага не зависит.
     *
     * Каждое лицо правится в СВОЕЙ области своей моделью — тем же путём, что
     * одно лицо в кадре (радиусы сглаживания и «кожи вокруг» — от его области,
     * а не от общей), по очереди: следующее берёт уже поправленные пиксели, а
     * вне своей маски ни одна правка пикселей не меняет. Своя у лица и сила:
     * огибающая дорожки (f.k) — лицо, входящее в кадр, проявляется за RAMP
     * кадров, пока соседнее в полную силу. У одного лица его область и есть
     * общая — путь побитово прежний.
     */
    function applyFrame(scene, job, a, tp, pr, k, explain) {
        // Кадр уже на холсте целиком; тяжёлую работу (перевод в линейное
        // пространство, растяжка модели, снятие блика, частотное
        // разделение) делаем в той же области. Вне маски результат и так
        // равен входу, а лицо занимает 5–10 % кадра: на замере 608×912
        // полнокадровая обработка стоила 385 мс на кадр, и почти всё это
        // уходило на пиксели, которые не меняются.
        var reg = job.reg;
        var full = root.FREngine.toPlanes(job.region);
        var ex = explain ? {
            shine: new Float32Array(reg.w * reg.h), skin: new Float32Array(reg.w * reg.h), feat: new Float32Array(reg.w * reg.h),
            spot: new Float32Array(reg.w * reg.h),
            x: reg.x, y: reg.y, w: reg.w, h: reg.h, faces: job.rfaces,
        } : null;
        var teethPx = -1, spotsHealed = -1, bigMain = null;
        for (var pi = 0; pi < a.parts.length; pi++) {
            var p = a.parts[pi], jp = job.parts[pi];
            if (!p || !p.ok) continue;
            var t = tp && tp.parts ? tp.parts[pi] : null;
            if (t && t.s) fromFaceSpace(t.s, FACE_GRID, p.spec, p.sw, p.sh, p.fb);
            if (t && t.f) {
                var G2 = FLOOR_GRID * FLOOR_GRID, fl = p.model.floor;
                fromFaceSpace(t.f.subarray(0, G2), FLOOR_GRID, fl.R, p.sw, p.sh, p.fb, true);
                fromFaceSpace(t.f.subarray(G2, 2 * G2), FLOOR_GRID, fl.G, p.sw, p.sh, p.fb, true);
                fromFaceSpace(t.f.subarray(2 * G2), FLOOR_GRID, fl.B, p.sw, p.sh, p.fb, true);
            }
            var pr0 = p.reg, ox = pr0.x - reg.x, oy = pr0.y - reg.y;
            var whole = ox === 0 && oy === 0 && pr0.w === reg.w && pr0.h === reg.h;
            var sub = whole ? full : cropPlanes(full, ox, oy, pr0.w, pr0.h);
            var face = job.rfaces[pi];
            var kf = face && face.k !== undefined ? Math.max(0, Math.min(1, face.k)) : k;
            var r = applyFace(scene, sub, p, jp.rface, jp.faceWidth, pr, kf, pi === 0, ex, ox, oy, reg.w);
            if (!whole) pastePlanes(full, r.res, ox, oy); else full = r.res;
            if (r.teethPx >= 0) teethPx = (teethPx < 0 ? 0 : teethPx) + r.teethPx;
            if (pi === 0) spotsHealed = r.spotsHealed;
            if (!bigMain) bigMain = r.big;
        }
        return { image: root.FREngine.toImageData(full, job.region), teethPx: teethPx, spotsHealed: spotsHealed, big: bigMain, explain: ex };
    }

    /** Цепочка правок одного лица в его области (sub — плоскости этой области). */
    function applyFace(scene, sub, p, rface, faceWidth, pr, k, main, ex, ox, oy, exW) {
        var w = sub.w, h = sub.h, faces = [rface];
        var whole = w === exW && !ox && !oy;
        var add = function (a, b, acc) { if (whole) addDelta(a, b, acc); else addDeltaAt(a, b, acc, exW, ox, oy); };
        // Пятна (вкладка «Пятна»): ДО всех правок — лечатся по исходнику, а
        // блеск и сглаживание потом работают уже по чистой коже. Пятна
        // привязаны к ГЛАВНОМУ лицу (у трекера оно всегда первое); −1 — пятен нет.
        var spotsHealed = -1, preSpots = null;
        if (main && pr.spots && pr.spots.length && root.FRHeal && rface && rface.pts) {
            if (ex) preSpots = root.FRHeal.clonePlanes(sub);
            spotsHealed = root.FRHeal.healSpots(sub, pr.spots, rface.pts, w, h);
        }
        var big = root.FREngine.rescaleModel(p.model, w, h, p.sw, p.sh, null, true);
        big.light = scene.light;
        var res = root.FREngine.deshine(sub, big, { amount: (pr.shine || 0) * k });
        if (ex) add(sub, res, ex.shine);
        if (ex && preSpots) add(preSpots, sub, ex.spot);
        var st0 = res;
        if (pr.smooth > 0 || pr.red > 0) {
            res = root.FRSmooth.smoothSkin(res, big, {
                strength: (pr.smooth || 0) * k, redness: (pr.red || 0) * k, faceWidth: faceWidth,
            });
        }
        if (ex && res !== st0) add(st0, res, ex.skin);
        // Зубы и белок — по СВОИМ контурам; лицо уже в координатах области.
        var teethPx = -1;              // −1: зубы не искали (ползунок на нуле)
        st0 = res;
        if ((pr.teeth > 0 || pr.sclera > 0) && root.FRFeatures) {
            if (pr.teeth > 0) {
                res = root.FRFeatures.whitenTeeth(res, faces, { amount: pr.teeth * k });
                teethPx = res.teethPx || 0;
            }
            if (pr.sclera > 0) res = root.FRFeatures.brightenEyes(res, faces, { amount: pr.sclera * k });
        }
        if (ex && res !== st0) add(st0, res, ex.feat);
        st0 = res;
        if (pr.eye > 0) res = root.FRSmooth.brightenUnderEye(res, big, faces, { amount: pr.eye * k });
        if (ex && res !== st0) add(st0, res, ex.skin);
        // Свет и тон кожи — ПОСЛЕДНИМИ. Они меняют уровень, от которого
        // считаются блик и полосы частот, поэтому применять их раньше
        // значило бы измерять одно, а править другое.
        if ((pr.exposure || pr.warmth) && root.FRTone) {
            res = root.FRTone.apply(res, big, { exposure: (pr.exposure || 0) * k, warmth: (pr.warmth || 0) * k });
        }
        return { res: res, teethPx: teethPx, spotsHealed: spotsHealed, big: big };
    }

    /** Общее начало кадра у обоих путей: огибающая, главное лицо. */
    function frameFaces(faces, pr, o) {
        var k = o.k === undefined ? 1 : Math.max(0, Math.min(1, o.k));
        // ── ТОЛЬКО ГЛАВНОЕ ЛИЦО ───────────────────────────────────
        // Интервью и подкаст снимают вдвоём, а на вебинаре в кадре
        // бывает плакат с портретом. Ретушировать всех — не «щедрее»,
        // а неверно: собеседник в расфокусе получает маску по нечёткой
        // геометрии, и это видно сильнее, чем польза. Отбор идёт ДО
        // сглаживания геометрии, чтобы сопоставление лиц между кадрами
        // считало одно и то же лицо.
        if (pr.mainFaceOnly && faces.length > 1) faces = [biggest(faces)];
        return { faces: faces, k: k };
    }

    function processorOptions(params) {
        return {
            smoothing: (params && params.temporal !== undefined) ? params.temporal : 0.65,
            floorSmoothing: (params && params.floorTemporal !== undefined) ? params.floorTemporal : 0.65,
            robustPasses: (params && params.robustPasses !== undefined) ? params.robustPasses : 1,
        };
    }

    function firstOk(a) {
        for (var i = 0; i < a.parts.length; i++) if (a.parts[i] && a.parts[i].ok) return a.parts[i];
        return {};
    }

    /**
     * Обработчик кадров с ПАМЯТЬЮ между кадрами — именно она убирает мерцание.
     */
    function createProcessor(scene, params) {
        var prevFaces = null, temporal = { prev: null };
        var geomAlpha = (params && params.geometry !== undefined) ? params.geometry : 0.6;
        var geomSnap = (params && params.geometrySnap !== undefined) ? params.geometrySnap : 0.02;
        var opt = processorOptions(params);
        var finder = createFinder({ track: true, deep: 'lost' });

        /**
         * Один кадр — СИНХРОННО и без поиска: лица уже известны.
         * @param {CanvasRenderingContext2D} outCtx  холст выдачи; кадр УЖЕ нарисован
         * @param {Array} faces  лица в долях кадра
         * @param {object} pr {shine, smooth, red, eye, teeth, sclera, exposure, warmth, mainFaceOnly}
         * @param {object} o  {k: огибающая 0..1, presmoothed: геометрия уже сглажена}
         */
        function render(outCtx, faces, outW, outH, pr, o) {
            var T = (typeof performance !== 'undefined') ? performance : Date;
            var t0 = T.now(), prof = {};
            o = o || {};
            pr = pr || {};
            var ff = frameFaces(faces, pr, o), k = ff.k;
            faces = ff.faces;
            if (geomAlpha > 0 && faces.length && !o.presmoothed) {
                faces = rebuildPolys(smoothFaces(prevFaces, faces, geomAlpha, geomSnap));
            }
            prevFaces = faces.length ? faces : null;
            // Кадра без лица касаться нельзя: любая «ретушь» там — порча. И
            // сглаживание во времени после него начинается заново.
            if (!faces.length || k <= 0) { temporal.gap = true; return { faces: faces.length, k: k }; }

            var job = takeFrame(scene, outCtx, faces, outW, outH);
            prof.take = T.now() - t0; t0 = T.now();
            var a = analyzeFrame(scene, job, opt);
            prof.analyze = T.now() - t0; t0 = T.now();
            if (!a.ok) return { faces: faces.length, ok: false, k: k };
            var tp = temporalStep(temporal, a, opt);
            var out = applyFrame(scene, job, a, tp, pr, k, !!o.explain);
            prof.apply = T.now() - t0; t0 = T.now();
            outCtx.putImageData(out.image, job.reg.x, job.reg.y);
            prof.output = T.now() - t0;
            return {
                faces: faces.length, ok: true, k: k, model: out.big, spec: firstOk(a).spec, prof: prof, teethPx: out.teethPx,
                spotsHealed: out.spotsHealed,
                // Главное лицо кадра — к его точкам привязываются новые пятна.
                mainFace: faces[0] || null,
                faceBoxNorm: faceBox(faces), explain: out.explain,
                smallW: firstOk(a).sw, smallH: firstOk(a).sh, region: job.reg,
            };
        }

        return {
            scene: scene,
            finder: finder,
            render: render,
            /**
             * Найти лица и обработать кадр (предпросмотр, запасной проход).
             * @param {*} source  video/canvas/ImageBitmap — кадр целиком
             * @param {CanvasRenderingContext2D} outCtx  куда рисовать результат
             */
            async frame(source, outCtx, outW, outH, pr, o) {
                var T = (typeof performance !== 'undefined') ? performance : Date;
                var t0 = T.now();
                var s = srcSize(source);
                var faces = await locate(finder, source, s.w, s.h);
                var detectMs = T.now() - t0;
                outCtx.drawImage(source, 0, 0, outW, outH);
                var r = render(outCtx, faces, outW, outH, pr, { explain: !!(o && o.explain) });
                if (r.prof) r.prof.detect = detectMs;
                return r;
            },
            reset: function () { temporal = { prev: null }; prevFaces = null; finder.reset(); },
        };
    }

    // ── Пул воркеров для экспорта ────────────────────────────────────────────
    /**
     * Несколько кадров сразу — тем же кодом, в воркерах (retouch-worker.js).
     *
     * Кадр видео независим от соседей во всём, кроме сглаживания поля блика во
     * времени, а оно стоит копейки (сетка 48×48). Поэтому разбор и применение
     * — 99 % работы кадра — уходят воркерам, а сглаживание остаётся здесь и
     * идёт строго по порядку кадров. Выдача побитово та же, что у
     * createProcessor().render с presmoothed:true: те же функции, те же входы.
     *
     * Замер 26.09.2026 (i9-13980HX под чужой нагрузкой, реальные кадры 1080p,
     * пресет Natural, пропускная способность против главного потока в той же
     * сессии): 2 воркера ×1.5, 3 — ×2.4, 4 — ×3.9.
     *
     * Контракт: render() зовётся В ПОРЯДКЕ КАДРОВ (так его зовёт конвейер с
     * geometry2d.concurrency) и возвращает обещание; когда оно исполнено,
     * область лица уже вписана в outCtx. Лица — уже сглаженные (presmoothed).
     *
     * @param {object} o {workerUrl, size, startTimeoutMs}
     * @return {Promise<object>} пул, когда все воркеры загрузили движок
     */
    function createPool(scene, params, o) {
        o = o || {};
        var opt = processorOptions(params);
        var size = Math.max(1, Math.min(8, (o.size | 0) || 1));
        var workers = [], pending = new Map(), analyzed = new Map();
        var seq = 0, nextTemporal = 0, temporal = { prev: null }, gapNext = false;
        var failed = null, closed = false;

        function fail(err) {
            if (failed) return;
            failed = err;
            pending.forEach(function (j) { j.reject(err); });
            pending.clear();
        }

        // Сглаживание во времени — строго по порядку кадров, как бы ни пришли разборы.
        function pump() {
            while (analyzed.has(nextTemporal)) {
                var r = analyzed.get(nextTemporal);
                analyzed.delete(nextTemporal);
                var j = pending.get(nextTemporal);
                if (j) {
                    // Перед этим кадром был кадр без лица — память с нуля, как
                    // в последовательном пути.
                    if (j.fresh) temporal.gap = true;
                    if (!r.ok) {
                        // Кожи не нашлось: кадр не трогаем, и памяти он не меняет —
                        // как в последовательном пути.
                        pending.delete(nextTemporal); j.w.load--;
                        j.resolve({ faces: j.faces.length, ok: false, k: j.k });
                    } else {
                        var tp = temporalStep(temporal, r, opt);
                        j.w.worker.postMessage({ cmd: 'apply', id: nextTemporal, grid: tp });
                    }
                }
                nextTemporal++;
            }
        }

        // Сторож тишины. Воркер, убитый браузером по памяти, не обязан прислать
        // ни ошибку, ни событие error — а обещание кадра тогда не исполнится
        // никогда, и экспорт встанет навсегда. Кадр считается сотни
        // миллисекунд; минута без единого ответа при кадрах в работе — отказ
        // пула, и экспорт переходит на главный поток.
        var clock = function () { return (typeof performance !== 'undefined') ? performance.now() : Date.now(); };
        var lastWord = clock();
        var STALL_MS = o.stallMs || 60000;
        var guard = setInterval(function () {
            if (closed || failed) { clearInterval(guard); return; }
            if (pending.size && clock() - lastWord > STALL_MS) {
                var err = new Error('retouch-pool: stalled');
                err.vrPool = true;
                fail(err);
                clearInterval(guard);
            }
        }, Math.min(5000, STALL_MS));

        function onMessage(w, e) {
            var m = e.data || {};
            lastWord = clock();
            if (m.cmd === 'ready') { w.onReady(); return; }
            if (m.cmd === 'error') {
                var err = new Error('retouch-worker: ' + m.message);
                err.vrPool = true;
                fail(err);
                return;
            }
            if (m.cmd === 'analyzed') { analyzed.set(m.id, m); pump(); return; }
            if (m.cmd === 'applied') {
                var j = pending.get(m.id);
                if (!j) return;
                pending.delete(m.id); w.load--;
                j.outCtx.putImageData(m.image, j.reg.x, j.reg.y);
                j.resolve({ faces: j.faces.length, ok: true, k: j.k, teethPx: m.teethPx, spotsHealed: m.spotsHealed, region: j.reg, faceBoxNorm: faceBox(j.faces) });
            }
        }

        // В воркер уходят только данные, которые читает движок: лишнее поле
        // лица, не переносимое структурным клоном, уронило бы весь экспорт.
        var FACE_KEYS = ['box', 'pts', 'oval', 'leftEye', 'rightEye', 'lips', 'mouthOpen', 'leftBrow', 'rightBrow', 'k'];
        function slimFaces(rfaces) {
            return rfaces.map(function (f) {
                var g = {};
                for (var i = 0; i < FACE_KEYS.length; i++) if (f[FACE_KEYS[i]] !== undefined) g[FACE_KEYS[i]] = f[FACE_KEYS[i]];
                return g;
            });
        }

        var api = {
            size: size,
            render: function (outCtx, faces, outW, outH, pr, ro) {
                if (failed) return Promise.reject(failed);
                if (closed) return Promise.reject(new Error('retouch-pool: closed'));
                ro = ro || {};
                pr = pr || {};
                var ff = frameFaces(faces, pr, ro), k = ff.k;
                faces = ff.faces;
                if (!faces.length || k <= 0) { gapNext = true; return Promise.resolve({ faces: faces.length, k: k }); }
                var job = takeFrame(scene, outCtx, faces, outW, outH);
                var id = seq++, fresh = gapNext;
                gapNext = false;
                var w = workers[0];
                for (var i = 1; i < workers.length; i++) if (workers[i].load < w.load) w = workers[i];
                w.load++;
                if (!pending.size) lastWord = clock();   // часы тишины — от первого кадра в работе
                return new Promise(function (resolve, reject) {
                    pending.set(id, { resolve: resolve, reject: reject, outCtx: outCtx, reg: job.reg, k: k, faces: faces, w: w, fresh: fresh });
                    var parts = job.parts.map(function (p) {
                        return { small: p.small, reg: p.reg, rface: slimFaces([p.rface])[0], faceWidth: p.faceWidth, key: p.key };
                    });
                    var moved = [job.region.data.buffer];
                    for (var q = 0; q < parts.length; q++) moved.push(parts[q].small.data.buffer);
                    w.worker.postMessage({
                        cmd: 'analyze', id: id, pr: pr, k: k,
                        job: { parts: parts, region: job.region, reg: job.reg, rfaces: slimFaces(job.rfaces), faceWidth: job.faceWidth },
                    }, moved);
                });
            },
            close: function () {
                if (closed) return;
                closed = true;
                clearInterval(guard);
                var err = new Error('retouch-pool: closed');
                pending.forEach(function (j) { j.reject(err); });
                pending.clear();
                workers.forEach(function (w) { try { w.worker.terminate(); } catch (_) { } });
            },
        };

        // Запуск ступенькой: первый воркер тянет движок по сети (семь скриптов),
        // остальные стартуют, когда он готов, — их импорт берётся из кэша
        // (версионированные ответы immutable). Все сразу — это N×7 одинаковых
        // запросов в одну секунду: локальный стенд под нагрузкой на этом ронял
        // importScripts с NetworkError (26.09.2026), и серверу это лишняя работа.
        return new Promise(function (resolve, reject) {
            var ready = 0, done = false;
            var to = setTimeout(function () {
                if (done) return;
                done = true; api.close();
                reject(new Error('retouch-pool: start-timeout'));
            }, o.startTimeoutMs || 20000);
            function settleErr(err) {
                if (done) { fail(err); return; }
                done = true; clearTimeout(to); api.close(); reject(err);
            }
            function spawn() {
                var wk;
                try { wk = new Worker(o.workerUrl); }
                catch (err) { settleErr(err); return; }
                var entry = {
                    worker: wk, load: 0,
                    onReady: function () {
                        if (done) return;
                        ready++;
                        if (ready === 1) for (var i = 1; i < size; i++) spawn();
                        if (ready === size) { done = true; clearTimeout(to); resolve(api); }
                    },
                };
                wk.onmessage = onMessage.bind(null, entry);
                wk.onerror = function (ev) {
                    var err = new Error('retouch-worker: ' + ((ev && ev.message) || 'failed to load'));
                    err.vrPool = true;
                    settleErr(err);
                };
                workers.push(entry);
                wk.postMessage({ cmd: 'init', scene: { light: scene.light }, params: params || {} });
            }
            spawn();
        });
    }

    root.FRVideo = {
        prepare: prepare, createProcessor: createProcessor, createPool: createPool, createFinder: createFinder, createTracker: createTracker,
        locate: locate, downscale: downscale, median: median, faceBox: faceBox, toFaceSpace: toFaceSpace, FACE_GRID: FACE_GRID,
        mapFaces: mapFaces, regionOf: regionOf,
        // Для воркера (retouch-worker.js): те же фазы, что у createProcessor.
        _phases: { takeFrame: takeFrame, analyzeFrame: analyzeFrame, temporalStep: temporalStep, applyFrame: applyFrame, processorOptions: processorOptions },
    };
})(typeof window !== 'undefined' ? window : globalThis);
